import { render, staticRenderFns } from "./OverviewListCustom.vue?vue&type=template&id=59ed14fd&"
import script from "./OverviewListCustom.vue?vue&type=script&lang=js&"
export * from "./OverviewListCustom.vue?vue&type=script&lang=js&"
import style0 from "./OverviewListCustom.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports